<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Orion_protect-shield 1">
      <path
        id="layer2"
        d="M16 1C13 4 7.9 5.9 3 1V12.05C3.09108 16.1302 4.36914 20.0955 6.6779 23.461C8.98666 26.8265 12.2261 29.4462 16 31C19.7739 29.4462 23.0133 26.8265 25.3221 23.461C27.6309 20.0955 28.9089 16.1302 29 12.05V1C24 6 18.85 3.85 16 1Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        id="layer1"
        d="M16 9V21M10 15H22"
        stroke="white"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
